import ReactPixel from "react-facebook-pixel";
import ReactGA from 'react-ga';

export function initializeAnalytics() {
    ReactGA.initialize('UA-133761327-2');
    ReactPixel.init('525695208169845');

}
